




























import { Vue } from "vue-property-decorator";
import Login from "./components/Login.vue";
import AccountSelector from "./components/AccountSelector.vue";

/*  AccountSelector */
export default Vue.extend({
  components: {
    "app-login": Login,
    "app-account-selector": AccountSelector
  },
  data: () => {
    return {
      selectedComponent: "app-login" as String,
      dictationAccounts: [] as any
    };
  },
  methods: {
    switchToAccountSelector(DictationAccounts: any) {
      this.selectedComponent = "app-account-selector";
      this.dictationAccounts = DictationAccounts;
      setTimeout(() => {
        this.selectedComponent = "app-login";
      }, 5 * 60 * 1000);
    }
  }
});
